<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16KyZHY/tc-custom/9781504070898.jpg?1704510775709" alt="This image is the cover for the book How To Kill Your Friends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How To Kill Your Friends
      </h1>
      <p class="bookDescription body article font2">
        <b>In this psychological thriller, an American grifter in Barcelona is determined to befriend a group of social media influencers—no matter what it takes.</b><br/><br/>There’s something about Meredith . . .<br/><br/>Meredith is a young underachiever, living in a squalid apartment, struggling to stay one step ahead of her landlord and the law when she meets a man from her past who offers her a way out and a chance to start over.<br/><br/>Having worked her way into the lives of the rich and privileged, Meredith will do just about anything to preserve her new lifestyle. But just how far is she prepared to go?<br/><br/><b>Phil Kurthausen is also the author of the psychological thriller <i>Don’t Let Me In</i>. <i>How To Kill Your Friends</i> is perfect for fans of authors like Rachel Abbott, Kerry Wilkinson, and Mark Edwards.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phil Kurthausen
      </h2>
      
      <p class="authorDescription body article">Phil Kurthausen was brought up in Merseyside where he dreamt of being a novelist but ended up working as a lawyer.  He has travelled the world working as a light bulb repair technician, a flower salesman and, though scared of heights, painted Sydney Harbour Bridge. Ken Dodd once put him in a headlock for being annoying.  His work has been broadcast on BBC radio 4 extra, he has published some short stories and his novel ‘The Silent Pool’ won the Thriller Round in the Harper Collins People’s Novelist Competition broadcast on ITV in November 2011 and appeared in the final. It was later shortlisted for the Dundee International Literary Prize in 2012.  More recently 'The Silent Pool' won Apple book of the month and his novel ‘Sudden Death’ was a best seller on the Amazon kindle charts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67ed7a76